import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { colors } from '../../../styles';
import { ColumnToggleProps } from './column-toggle';
import ColumnCheckbox from './column-checkbox';
import ColumnToggleSection from './column-section';

export interface Props extends ColumnToggleProps {
  sections: string[];
  checked: boolean;
}

class CollumnToggleSections extends React.Component<Props> {
  getSectionColumns = (section: string) =>
    this.props.columns.filter(c => c.sectionName === section);

  sectionCheckBoxState = (section: string) =>
    this.getSectionColumns(section).every(
      ({ dataKey }) => this.props.visibleColumns[dataKey],
    );

  onCheck = () => {
    const {
      checked: selectAllChecked,
      visibleColumns,
      columns,
      toggleColumns,
    } = this.props;

    const columnKeysToToggle = columns.reduce((result, { dataKey }) => {
      const columnChecked = visibleColumns[dataKey];
      return selectAllChecked || !columnChecked ? [...result, dataKey] : result;
    }, []);
    toggleColumns(columnKeysToToggle);
  };

  render() {
    const { className, sections, checked, selectAllLabel } = this.props;

    return (
      <div className={className}>
        <ColumnCheckbox
          className="select-all"
          label={selectAllLabel}
          checked={checked}
          onCheck={this.onCheck}
        />
        {sections.map((section, key) => (
          <ColumnToggleSection
            {...this.props}
            key={key}
            section={section}
            sectionColumns={this.getSectionColumns(section)}
            checked={this.sectionCheckBoxState(section)}
          />
        ))}
      </div>
    );
  }
}

export default styled(CollumnToggleSections)`
  background: ${colors.grey10};

  .select-all {
    border-top: 1px solid ${colors.grey150};
  }
`;
